import { AxiosInstance } from 'axios';
import { AddressEntity, AddressTypeEnum } from '../state/addresses/types';
import { DataPayload } from '../state/types';

const companyAddressesUrl = (companyId: string) =>
  `/api/v1/company/${companyId}/addresses`;

const AddressesApi = {
  createAddress: async (
    axios: AxiosInstance,
    address: Omit<AddressEntity, '_id'>,
    companyId: string
  ): Promise<AddressEntity> => {
    const response = await axios.post(companyAddressesUrl(companyId), address);
    return response.data;
  },

  updateAddress: async (
    axios: AxiosInstance,
    addressId: string,
    address: Omit<AddressEntity, '_id'> & { lastModifiedBy: string },
    companyId: string
  ): Promise<AddressEntity> => {
    const response = await axios.put(
      `${companyAddressesUrl(companyId)}/${addressId}`,
      address
    );
    return response.data;
  },

  deleteAddress: async (
    axios: AxiosInstance,
    addressId: string,
    companyId: string
  ): Promise<AddressEntity> => {
    const response = await axios.delete(
      `${companyAddressesUrl(companyId)}/${addressId}`
    );
    return response.data;
  },

  getCompanyAddresses: async (
    axios: AxiosInstance,
    companyId: string,
    params: {
      paginate: boolean;
      limit?: number;
      page?: number;
      sortColumn?: string;
      sortDirection?: number;
      filters?: {
        addressTypes?: AddressTypeEnum[];
        search?: string;
        hasLocation?: boolean;
      };
    }
  ): Promise<DataPayload<AddressEntity>> => {
    const response = await axios.get(companyAddressesUrl(companyId), {
      params,
    });
    return response.data;
  },

  getLabAddresses: async (
    axios: AxiosInstance,
    companyId: string
  ): Promise<DataPayload<AddressEntity>> => {
    const response = await axios.get(companyAddressesUrl(companyId), {
      params: {
        limit: 1000, // TODO: Remove pagination once backend supports it
        page: 0,
        filters: {
          addressTypes: [AddressTypeEnum.LAB],
        },
      },
    });
    return response.data;
  },
};

export default AddressesApi;
